import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Select, Input } from 'antd';
import FormItem from "components/fields/FormItem";
import { 
	getAnimalTypes, getCattleBreeds, getGoatBreeds, getSheepBreeds
} from "../../redux/dynamiclist/dynamicListState";

import { renderLabel } from '../../utils/index';
import { ANIMAL_TYPE_CARABAO,
ANIMAL_TYPE_CATTLE,
ANIMAL_TYPE_GOAT,
ANIMAL_TYPE_SHEEP,
ANIMAL_TYPE_SWINE } from '../../variables/constants';
import SelectWithOthers from "components/fields/SelectWithOthers";

const AnimalTypeAndBreed = ({recordData, mode, form,
	getAnimalTypeList, getCattleBreedList, getGoatBreedList, getSheepBreedList,
	animalTypes, cattleBreeds, goatBreeds, sheepBreeds, rules, typeId}) => {

	const [animalBreeds, setAnimalBreeds ] = useState([]);
	
	const handlAnimalTypeChange = (value) => {
		form.setFieldsValue({
			...form.getFieldsValue(),
			breed_id: null,
		});
		getAnimalTypeBreeds(value);
    };

	const getAnimalTypeBreeds = (typeId) => {
		if (!typeId) {
			setAnimalBreeds([]);
			return;
		}
		switch(typeId){
			case ANIMAL_TYPE_CATTLE:
				cattleBreeds ? setAnimalBreeds(cattleBreeds) : getCattleBreedList({});
				break;
			case ANIMAL_TYPE_GOAT:
				goatBreeds ? setAnimalBreeds(goatBreeds) : getGoatBreedList({});
				break;
			case ANIMAL_TYPE_SHEEP:
				sheepBreeds ? setAnimalBreeds(sheepBreeds) : getSheepBreedList({});
				break;	
			default:
				setAnimalBreeds([]);
			break;
		}
	}

	// useEffect(() => {
	// 	getAnimalTypeList({});
	// }, [getAnimalTypeList]);

	useEffect(() => {
		//const typeId = form.getFieldValue('type_id');
		getAnimalTypeBreeds(typeId);
	}, [form, cattleBreeds, goatBreeds, sheepBreeds]);
	
  	return (
		<>
			<FormItem 
				name="type_id"
				label="Type"
				hidden
			>
				<Input type="hidden" id="type_id"/>
				{/* {mode === 'edit' ?
				<Select id="type_id"
					allowClear={true}
					options={animalTypes}
					onChange={handlAnimalTypeChange}
				/>					
				: renderLabel(recordData?.type?.name)
				}                 */}
			</FormItem>
			<FormItem 
				name="breed_id"
				label="Breed"
				rules={rules}
			>
				{mode === 'edit' ?
				<SelectWithOthers 
					mode={mode}
					selectFieldName="breed_id" 
					selectOptions={animalBreeds} 
					selectDisplayValue={recordData?.breed_id}
					othersFieldName="breed_others_name"
					othersDisplayValue={recordData?.breed_others_name}
					optionOthersId={[35,47,58]}
					direction="vertical"
					othersStyle={{maxLength: 100}}	
				/>				
				: renderLabel(recordData?.breed?.name)
				}                
			</FormItem>
        </>
  );
}

const mapStateToProps = (state) => ({
	animalTypes: state.dynamicList.animalTypes?.items,
	cattleBreeds: state.dynamicList.cattleBreedList?.items,
	goatBreeds: state.dynamicList.goatBreedList?.items,
	sheepBreeds: state.dynamicList.sheepBreedList?.items,
});

const mapDispatchToProps = (dispatch) => ({
	getAnimalTypeList: (data) => dispatch(getAnimalTypes(data)),
	getCattleBreedList: (data) => dispatch(getCattleBreeds(data)),
	getGoatBreedList: (data) => dispatch(getGoatBreeds(data)),
	getSheepBreedList: (data) => dispatch(getSheepBreeds(data)),	
});

export default connect(mapStateToProps, mapDispatchToProps)(AnimalTypeAndBreed);